import merge from 'lodash/merge'

import dividerMap from './dividers'

function renderDivider(topOrBottom, props = {}) {

  let { shape, height, flip, color, } = props
  let selector = `&:${topOrBottom === 'top' ? 'before' : 'after'}`
  let obj = {}

  obj = {
    [selector]: {
      '--dividerMask': dividerMap[shape],
      'content': '""',
      'height': height + 'vw',
      'background-color': color,
      'width': '100%',
      'left': '0',
      'position': 'absolute',
      'mask-repeat': 'no-repeat',
      '-webkit-mask-repeat': 'no-repeat',
      '-webkit-mask-image': 'var(--dividerMask)',
      'mask-image': 'var(--dividerMask)',
      '--rotate': 'rotate(0deg)',
      '--scale': 'scaleX(1)',
      'transform': 'var(--scale) var(--rotate)',
      'z-index': '1'
    }
  }
  
  if(flip) {
    obj = merge(obj, {
      [selector]: {
        '--scale': `scaleX(-1)`,
      }
    })
  }
  
  if(topOrBottom === 'bottom') {
    obj = merge(obj, {
      [selector]: {
        'bottom': '-1px',
        '--rotate': 'rotate(180deg)' 
      }
    })
  }

  if(topOrBottom === 'top') {
    obj = merge(obj, {
      [selector]: {
        'top': '-1px',
      }
    })
  }

  return obj 
  
}

export default function baseDividerStyles(props = {}) {
  
  let { top, bottom } = props

  let obj = { }

  if(top && top.enabled) {
    obj = merge(obj, renderDivider('top', top))
  }

  if(bottom && bottom.enabled) {
    obj = merge(obj, renderDivider('bottom', bottom))
  }

  return obj
}
